import { useGameReportData } from '@/hooks/gameReport/useGameReportData';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import Link from '@/components/core/Link';
import GameCardSkeleton from './Skeleton';
import { Image } from '@starsoft/common/components';

export default function GameCard() {
  const { t } = useTranslation('seo');
  const { t: tGameReport } = useTranslation('game-report');
  const { game, isPending } = useGameReportData();

  if (isPending) {
    return <GameCardSkeleton />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.container__row}>
        <Image
          className={styles.container__banner}
          src={game?.image}
          alt={game?.name}
        />

        <div className={styles.container__column}>
          <span className={styles.container__text}>{game?.name}</span>
          <span
            className={`${styles.container__text} ${styles['container__text--secondary']}`}
          >
            {t('label_originals', {
              app_provider: process.env.NEXT_PUBLIC_BET_NAME,
            })}
          </span>
        </div>
      </div>

      <Link
        href={game?.path ?? ''}
        className={`${styles.container__link} ${styles['container__link--secondary']}`}
      >
        {tGameReport('play')}
        <i className="fa-solid fa-chevron-right" />
      </Link>
    </div>
  );
}
